"use strict";

import { SITE_BRAND_ADD, SITE_BRAND_CLEAN } from "@/store/mutation-types";
import _ from "lodash";
import Vue from "vue";

const SIGNUP_SETTING_TYPE_NO_ONE = "no_one";
const SIGNUP_SETTING_TYPE_ANY_ONE = "any_one";
const SIGNUP_SETTING_TYPE_EMAIL_SUFFIX = "email_suffix";
const SIGNUP_SETTING_TYPE_PIN_CODE = "pin_code";

const DEFAULT_BRAND = {
  brand: "",
  title: "",
  links: [],
  count: { users: 0 },
  cover_image_url: "",
  logo_attachment_url: "",
  homepage_url: "",
  heading: "",
  hidden: false,
  expiration_time: null,
  signup_setting_type: "",
  signup_setting_value: "",
  signup_setting_hint: "",
  signin_redirection_page: "",
  signin_placeholder_of_username: "",
  signin_placeholder_of_password: "",
  signin_link_of_forgot_password: "",
  user_labels: [],
  signin_link_of_forgot_password_disabled: false,
  signin_method_cn_authed_enabled: false,
  signin_method_cn_login_disabled: false,
  signin_method_ms_azure_enabled: false,
};

const createDefaultState = () => _.cloneDeep(DEFAULT_BRAND);

const state = createDefaultState();

const mutations = {
  [SITE_BRAND_ADD](state, payload = {}) {
    Object.assign(state, {
      ...createDefaultState(),
      ...payload,
      cover_image_url: _.get(payload, "cover_image_attachment.view_url", ""),
      logo_attachment_url: _.get(payload, "logo_attachment.view_url", ""),
      signup_setting_value: _.get(payload, "signup_setting_args.value", ""),
      links: _.get(payload, "links", []),
      count: _.get(payload, "count", { users: 0 }),
      user_labels: _.get(payload, "user_labels", []),
    });
  },

  [SITE_BRAND_CLEAN](state) {
    Object.assign(state, createDefaultState());
  },
};

const actions = {
  checkUserSignup({ state }, payload = {}) {
    const { email, pinCode } = payload;

    return Vue.http
      .get("site_brand_signup_user_check", {
        params: {
          email,
          signup_site_brand_pin_code: pinCode,
          signup_site_brand: state.brand,
        },
      })
      .then(({ data }) => data);
  },

  setupBrand({ commit }, brandName) {
    return Vue.http
      .get("site_brand", {
        params: {
          brand: brandName,
          with_site_brand_logo_attachment: 1,
          with_site_brand_cover_image_attachment: 1,
          with_site_brand_count_users: 1,
          with_site_brand_count_institution_users: 1,
          with_site_brand_user_labels: 1,
        },
      })
      .then(({ data }) => {
        const brandData = _.get(data, "data[0]");
        if (brandData) {
          commit(SITE_BRAND_ADD, brandData);
        }
        return data;
      });
  },
};

const getters = {
  isTypeCode(state) {
    return SIGNUP_SETTING_TYPE_PIN_CODE === state.signup_setting_type;
  },

  enabledUserLabelSelfSelection(state) {
    return !_.isEmpty(state.user_labels);
  },

  userLabels(state) {
    const userLabels = (state.user_labels || []).map((label) => ({
      value: label,
      text: label,
    }));

    return [{ value: null, text: "Please Select One" }, ...userLabels];
  },

  isTypeEmail(state) {
    return SIGNUP_SETTING_TYPE_EMAIL_SUFFIX === state.signup_setting_type;
  },

  isExpired(state) {
    return Boolean(state.expiration_time && Date.now() / 1e3 > state.expiration_time);
  },

  isDisabled(state, getters) {
    return state.hidden || getters.isExpired;
  },

  isTypeNoOne(state, getters) {
    return SIGNUP_SETTING_TYPE_NO_ONE === state.signup_setting_type || state.hidden || getters.isExpired;
  },

  isTypeAnyOne(state) {
    return SIGNUP_SETTING_TYPE_ANY_ONE === state.signup_setting_type;
  },

  getSignupEmailHint(state, getters) {
    return getters.isTypeEmail ? state.signup_setting_value : null;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
